import Brev12 from './BrevSox';

export default function() {
    Brev12();
}
